module.exports = __webpack_public_path__ + "img/city-template-cta.7333a4c6.webp";